
<h2 style="text-align: center;">Liste des transactions</h2>
<p *ngIf="userinfos.length==0&&usertype!='Agence'&&usertype!='Metier'||loading"style="text-align: center;">veuillez patientez! vos transactions sont en cours de chargement ...</p>
<div id="loader" *ngIf="userinfos.length==0&&usertype!='Agence'&&usertype!='Metier'||loading">
  
</div>
<div *ngIf="userinfos.length>0||!loading">
    
  <div class="container mt-5"[ngStyle]="{'display':displaysearch}">
    <div class="row d-flex justify-content-center">
        <div class="col-md-10">
            <div class="card p-3  py-4">
              <fieldset *ngIf="usertype=='Clientcomm'||usertype=='Clientpor'">
                <legend>liste des cartes associèes au compte du client:</legend>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Compte</th>              
                      <th scope="col">Carte</th>
                      <th scope="col">Confirmation</th>          
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let info of userinfos,let i=index"> 
                      <td><span>{{info.compte}}</span></td>
                      <td><span>{{info.carte |truncatecard}}</span></td>
                      <td style="width:20px"> 
                        <input type="checkbox" id="{{ 'checkuserinfo' + i }}"/>
                      </td> 
                    </tr>
                    </tbody>
                  </table>
    <button class="btn btn-primary btn-block"(click)="search()"><i class="fa fa-search"></i><i class="fa fa-refresh fa-spin" *ngIf="loading"></i>Charger plus</button>                
              </fieldset>
              <fieldset class="p-4 border rounded">
                <h5 class="text-secondary mb-4">Chercher Transaction</h5>
                <div class="card shadow-sm p-3 mb-4 border-0">
                  <!-- Merchant ID and Card Number Fields -->
                  <div class="row g-3 align-items-center">
                    <div class="col-md-2 text-end">
                      <label class="form-label mb-0" for="merchantId">ID commerçant:</label>
                    </div>
                    <div class="col-md-4">
                      <input 
                        type="text" 
                        placeholder="ID commerçant" 
                        class="form-control form-control-lg" 
                        [(ngModel)]="option1Value" 
                        id="merchantId"
                      />
                    </div>
                    <div class="col-md-2 text-end" *ngIf="usertype !== 'Clientcomm' && usertype !== 'Clientpor'">
                      <label class="form-label mb-0" for="cardNumber">Numéro de carte:</label>
                    </div>
                    <div class="col-md-4" *ngIf="usertype !== 'Clientcomm' && usertype !== 'Clientpor'">
                      <input 
                        type="text" 
                        class="form-control form-control-lg" 
                        placeholder="Numéro de carte" 
                        [(ngModel)]="option2Value" 
                        id="cardNumber"
                      />
                    </div>
                  </div>
              
                  <!-- Date Range Fields -->
                  <div class="row g-3 align-items-center mt-3">
                    <div class="col-md-2 text-end">
                      <label class="form-label mb-0" for="dateFrom">Supérieur à:</label>
                    </div>
                    <div class="col-md-4">
                      <input 
                        type="date" 
                        class="form-control form-control-lg" 
                        [(ngModel)]="option3Value" 
                        id="dateFrom"
                      />
                    </div>
                    <div class="col-md-2 text-end">
                      <label class="form-label mb-0" for="dateTo">Inférieur à:</label>
                    </div>
                    <div class="col-md-4">
                      <input 
                        type="date" 
                        class="form-control form-control-lg" 
                        [(ngModel)]="option4Value" 
                        id="dateTo"
                      />
                    </div>
                  </div>
                </div>
              
                <!-- Search Button -->
                <div class="d-flex justify-content-end mt-3">
                  <button 
                    class="btn btn-primary btn-lg d-flex align-items-center gap-2" 
                    (click)="filtercompconf()" 
                  >
                    <i class="fa fa-search"></i> Chercher
                  </button>
                </div>
              </fieldset>
              
              
    
</div>         
</div>     
</div>
</div>  
      <mat-paginator *ngIf="filtredcompconfsbyportcomm.length>0"(page)="onPageChange($event)"[length]="filtredcompconfsbyportcomm.length"[pageSize]="100"[pageSizeOptions]="[100,200,500,1000]"></mat-paginator>
      <mat-paginator *ngIf="filtredcompconfsbyportcomm.length==0"(page)="onPageChange($event)"[length]="compconfs.length"[pageSize]="100"[pageSizeOptions]="[100,200,500,1000]"></mat-paginator>
      <!-- Button trigger modal -->
<button type="button" (click)="createtransaction()"class="btn btn-primary btn-lg d-flex align-items-center gap-2"data-bs-toggle="modal"data-bs-target="#filter"*ngIf="sumitemcoched>0">Générer réclamation</button>
          <!-- Modal -->
          <div class="modal fade" id="filter">
            <div class="modal-dialog modal-fullscreen">
              <div class="modal-content">
      <!--modal for multi rec add-->
      <div class="modal-header border-bottom-0 py-2 bg-grd-primary">
        <div class="card">
          <div class="card-body">
              <div class="d-flex flex-lg-row flex-column align-items-start align-items-lg-center justify-content-between gap-3">
                 <div class="flex-grow-1">
                   <h4 class="fw-bold">Enrichissement des réclamations</h4>
                 </div>
    
              </div>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12 col-lg-8 d-flex">
             <div class="card w-100">
              <div class="card-body">
                <h5 class="mb-3 fw-bold">Liste des réclamations<span class="fw-light ms-2">{{filtreditemschecked.length}}</span></h5>
                <div class="product-table">
                  <div class="table-responsive white-space-nowrap">
                     <table class="table align-middle">
                <thead class="table-light">
                  <tr>
                    <th >Date transaction</th>
                    <th >Heure transaction</th>
                    <th >Carte</th>
                    <th >Montant</th>
                    <th >Code Autorisation</th>
                    <th >Nom Commerçant</th>
                    <th >ID commerçant</th>
                    <th >Type de transaction</th>
                    <th >Acquéreur</th>
                    <th >Canal</th>
                    <th *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">Date expiration</th>
      <th *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">Emetteur</th>
      <th *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">ARN</th>
                    <th *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">Cycle de trasnaction</th>
                    <th *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">Montant compensé</th>
                  </tr>
                 </thead>
                 <tbody *ngIf="filtreditemschecked.length>0">
                  <tr *ngFor="let comp of transactions, let i=index">
                    <td>{{comp.TRANSACTIONDATE|customDate}}</td>
                    <td>{{comp.TRANSACTIONTIME}}</td>
                    <td>{{comp.CARDHOLDERNUMBER |truncatecard}}</td>
                    <td>{{comp.TRANSACTIONAMOUNT | formatAmount}}</td>
                    <td>{{comp.AUTHORIZATIONCODE}}</td>
                    <td>{{comp.MERCHANTNAME}}</td>
                    <td>{{comp.MERCHANTIDENTIFICATION}}</td>
                    <td>{{filtervalue(comp.TRANSACTIONCODE)}}</td>
                    <td>{{comp.ACQUIRERBANKIDENTIFICATION |changebanque}}</td>
                    <td>{{filtervalue(comp.CHANNELTRANSACTIONID)}}</td>
                    <td *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">{{comp.CARDEXPIRYDATE}}</td>
                    <td *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">{{comp.ISSUERBANKIDENTIFICATION |changebanque}}</td>
                    <td *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">{{comp.ACQUIRERREFERENCENUMBER}}</td>
                    <td *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">{{comp.TRANSACTIONORDERUSAGECODE}}</td>
                    <td *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">{{comp.SETTLEMENTAMOUNT | formatAmount}}</td>
                  </tr>
                 </tbody>
               </table>
                  </div>
                </div>
              </div>
             </div>
          </div>
          <div class="col-12 col-lg-4 d-flex">
            <div class="w-100"> 
            <div class="card">
              <div class="card-body"[formGroup]="reclamationform">
                <h4 class="card-title mb-4 fw-bold">Formulaire d'enrichissement de la réclamation</h4>
                <label class="form-label">Objet</label>
                <select class="form-select mb-4" id="topicSelect" formControlName="topic" name="topic" (change)="onTopicChange($event)">
                  <option hidden [value]=""></option>
                  <option value=""></option>
                  <option *ngFor="let top of topics" [value]="top">
                    {{top}}
                  </option>
                  <option hidden value="Autre">Autre</option>
                </select>
      
                <label class="form-label">Détail</label>
                <select class="form-select"*ngIf="filteredSubtopics.length>0" id="subtopicSelect" formControlName="subtopic" name="subtopic">
                  <option hidden [value]=""></option>
                  <option value=""></option>
                  <option *ngFor="let subtop of filteredSubtopics" [value]="subtop.subtopic">
                    {{subtop.subtopic}}
                  </option>
                  <option hidden value="Autre">Autre</option>
                </select>
      
                <label class="form-label">Commentaire</label>
                <textarea type="text" class="form-control" formControlName="commentaire" id="commentaire" placeholder=" Entrez commentaire"name="" id="" cols="30" rows="10"></textarea>
      
                <label class="form-label">Attacher votre document</label>
                <input type="file"multiple  #filePicker (change)="onImagePick($event)" class="form-control" accept="application/pdf">
                <div class="image-preview" *ngIf="imagePreview">
                  <img [src]="imagePreview" alt="">
                </div>
                <p class="text-success" *ngIf="fileUploaded">Fichier chargé !</p>  
              </div>
            </div>
          </div>
         </div>
       </div>
      </div>
      <div class="modal-footer border-top-0">
        <button type="button" class="btn btn-outline-primary"(click)="onSubmit()"data-bs-dismiss="modal">
          <i class="fa fa-refresh fa-spin"*ngIf="loading"></i>Valider réclamation
        </button>          
        <button type="button" class="btn btn-outline-danger"(click)="closePopupenr()"data-bs-dismiss="modal" id="dismissbutton">
          <i class="fa fa-refresh fa-spin"*ngIf="deleting"></i>Annuler
        </button>
      </div>
<!--end row-->
              </div>
            </div>
          </div>
    <table class="table table-striped" >
      <thead>
        <tr>
          <th >Date transaction</th>
          <th >Heure transaction</th>
          <th >Carte</th>
          <th >Montant</th>
          <th >Code Autorisation</th>
          <th >Nom Commerçant</th>
          <th >ID commerçant</th>
          <th >Type de transaction</th>
          <th >Acquéreur</th>
          <th >Canal</th>
          <th *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">Date expiration</th>
<th *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">Emetteur</th>
<th *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">ARN</th>
          <th *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">Cycle de trasnaction</th>
          <th *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">Montant compensé</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let comp of currentItemsToShownormal,let i=index">
          <td>{{comp.TRANSACTIONDATE|customDate}}</td>
          <td>{{comp.TRANSACTIONTIME}}</td>
          <td>{{comp.CARDHOLDERNUMBER |truncatecard}}</td>
          <td>{{comp.TRANSACTIONAMOUNT | formatAmount}}</td>
          <td>{{comp.AUTHORIZATIONCODE}}</td>
          <td>{{comp.MERCHANTNAME}}</td>
          <td>{{comp.MERCHANTIDENTIFICATION}}</td>
          <td>{{filtervalue(comp.TRANSACTIONCODE)}}</td>
          <td>{{comp.ACQUIRERBANKIDENTIFICATION |changebanque }}</td>
          <td>{{filtervalue(comp.CHANNELTRANSACTIONID)}}</td>
          <td *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">{{comp.CARDEXPIRYDATE}}</td>
          <td *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">{{comp.ISSUERBANKIDENTIFICATION |changebanque}}</td>
          <td *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">{{comp.ACQUIRERREFERENCENUMBER}}</td>
          <td *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">{{comp.TRANSACTIONORDERUSAGECODE}}</td>
          <td *ngIf="usertype!='Clientcomm'&&usertype!='Clientpor'">{{comp.SETTLEMENTAMOUNT | formatAmount}}</td>
                  <td style="width:20px"> 
                    <input type="checkbox" id="{{ 'checktransactioninfo' + i }}"[disabled]="!displaytran(comp.ACQUIRERREFERENCENUMBER)"(click)="verifydeadline(comp.PROCESSINGDATE,i)"/>
                  </td> 
                <td *ngIf="!displaytran(comp.ACQUIRERREFERENCENUMBER)" style="display: flex;"><span style="color: red;">Réclamée</span><button type="button" class="btn btn-black" (click)="getNavigation('reclamation/create-reclamation',visitrec(comp.ACQUIRERREFERENCENUMBER))"> Consulter</button>                
                </td>    
        </tr>
        </tbody>
    </table> 
</div>
 